module.exports = __webpack_public_path__ + "img/530-8edd5e.png";